import React, { useState } from "react";
import BuyPlan from "./PlanPurchase/BuyPlan";

const Trial = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [isRider, setIsRider] = useState(false);

  const benefits = [
    {
      title: "Tele Consultation",
      subtitle: "1 session with a general physician",
      icon: "🩺",
      iconBg: "bg-blue-50",
    },
    {
      title: "Video Consultation",
      subtitle: "1 video session with a general physician",
      icon: "🎥",
      iconBg: "bg-teal-50",
    },
  ];

  const stats = [
    { num: "₹149", label: "One time" },
    { num: "2", label: "Consultations" },
    { num: "GP", label: "Specialists" },
  ];

  const trustPoints = [
    "No hidden charges",
    "Instant activation",
  ];

  return (
    <>
      <section className="py-20 md:py-28 max-md:pt-[120px]">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl border border-gray-200 bg-white overflow-hidden shadow-lg">
            <div className="grid lg:grid-cols-2 min-h-[560px]">

              {/* Left — Image Panel */}
              <div className="relative flex items-center justify-center bg-gray-50 min-h-[320px]">
                <img
                  src="/assets/img/trial.svg"
                  alt="Healthcare Plan"
                  className="w-[80%] h-auto object-contain relative z-10"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-0" />
              </div>

              {/* Right — Content */}
              <div className="flex flex-col p-8 lg:p-12">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 text-xs font-medium w-fit mb-4">
                  ✨ Preview plan
                </span>

                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                  Preview Plan
                </h2>

                <p className="text-gray-500 text-sm mb-4 leading-relaxed">
                  Get a taste of our healthcare services before upgrading to a full plan.
                </p>

                {/* Price */}
                <div className="flex items-baseline gap-2 mb-7">
                  <span className="text-4xl font-bold text-gray-900">₹149</span>
                  <span className="text-gray-500 text-sm">+ GST</span>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-3 mb-7">
                  {stats.map((s, i) => (
                    <div key={i} className="rounded-xl border border-gray-200 bg-gray-50 p-3 text-center">
                      <div className="text-lg font-bold text-gray-900">{s.num}</div>
                      <div className="text-[11px] text-gray-500 mt-0.5">{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* Benefits */}
                <div className="space-y-3 mb-6">
                  {benefits.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-4 p-4 rounded-2xl border border-gray-200 hover:border-blue-300 transition-colors"
                    >
                      <div className={`w-11 h-11 rounded-xl flex items-center justify-center text-xl ${item.iconBg}`}>
                        {item.icon}
                      </div>
                      <div className="flex-1">
                        <h4 className="font-semibold text-gray-900 text-sm">{item.title}</h4>
                        <p className="text-xs text-gray-500 mt-0.5">{item.subtitle}</p>
                      </div>
                      <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gray-100">
                        <svg className="h-3 w-3 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Divider */}
                <div className="border-t border-gray-100 mb-5" />

                {/* Trust points */}
                <div className="flex flex-wrap gap-x-5 gap-y-2 mb-7">
                  {trustPoints.map((pt, i) => (
                    <div key={i} className="flex items-center gap-1.5 text-xs text-gray-500">
                      <svg className="w-3.5 h-3.5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {pt}
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <div className="mt-auto">
                  <button
                    onClick={() => {
                      setPlanCode("previewplan");
                      setOpenPopup(true);
                      setIsRider(true);
                    }}
                    className="w-full flex items-center justify-center gap-2  text-white py-4 rounded-2xl font-semibold text-base transition-all duration-300 shadow-md hover:shadow-lg  btn-gradient"
                  >
                    Buy Plan
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <BuyPlan
        planCode={planCode}
        tenantId="T4236001XTE"
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        isRider={isRider}
        showMember={false}
        memberCount={0}
        showRC={false}
      />
    </>
  );
};

export default Trial;